import React from 'react';

import { TextInputTheme } from './types';

export type SelectionRange = [start: number, end: number];

export const getIconColor = (
  color?: string,
  errorColor?: string,
  error?: string
): string | undefined => {
  if (error) {
    return errorColor;
  }
  return color;
};

// Return the selection range moved back for the inputted letter
export const getSelectionRange = (
  event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  offset: number
): SelectionRange => {
  const { target } = event;
  return [
    Math.max((target.selectionStart || 0) - offset, 0),
    Math.max((target.selectionEnd || 0) - offset, 0),
  ];
};

export const getIconTheme = (
  _theme: TextInputTheme,
  errorMessage?: string
): {
  color?: string;
  activeDefaultColor?: string;
  activeColor?: string;
  transition?: string;
} => {
  return {
    color: getIconColor(
      _theme?.icon?.color ?? _theme?.color,
      _theme?.colorError,
      errorMessage
    ),
    activeDefaultColor: getIconColor(
      _theme?.icon?.colorActive ?? _theme?.colorActive,
      _theme?.colorError,
      errorMessage
    ),
    activeColor: getIconColor(
      _theme?.icon?.colorActive ?? _theme?.colorActive,
      _theme?.colorError,
      errorMessage
    ),
    transition: _theme.transition,
  };
};
